export const types = {
  ACTION_SWITCH_ACCOUNT_SUCCESS: 'ACTION_SWITCH_ACCOUNT_SUCCESS',
  SET_LOGGED_ACCOUNT_TO_STORE: 'SET_LOGGED_ACCOUNT_TO_STORE',
  SET_USER_ACCOUNTS: 'SET_USER_ACCOUNTS',
};
